import React from "react";
import Show from "../show";
import { FormLabel } from "../form-label";
import Dropdown, { DropdownProps } from "../dropdown";
import { forwardRef, FormControl, FormHelperText } from "@chakra-ui/react";

export type Props = {
  height?: string;
  mb?: string | number;
  children?: undefined;
  isSearchable?: boolean;
  label?: React.ReactNode;
  helperText?: React.ReactNode;
} & DropdownProps;

const Select = forwardRef<Props, "select">(
  (
    {
      mb,
      label,
      value,
      options,
      helperText,
      isDisabled,
      menuStyles,
      inputStyles,
      placeholder,
      defaultValue,
      isSearchable,
      maxMenuHeight,
      getOptionValue,
      height = "56px",
      onChange = () => {}
    }: Props,
    ref
  ) => {
    inputStyles = {
      ...inputStyles,
      height,
      paddingLeft: "8px",
      borderRadius: "8px"
    };

    return (
      <FormControl height={height} mb={mb} data-cy="select-form-control">
        <Show iff={Boolean(label)}>
          <FormLabel display="block" data-cy="select-form-label">
            {label}
          </FormLabel>
        </Show>

        <Dropdown
          ref={ref}
          value={value}
          options={options}
          onChange={onChange}
          menuStyles={menuStyles}
          isDisabled={isDisabled}
          inputStyles={inputStyles}
          placeholder={placeholder}
          defaultValue={defaultValue}
          isSearchable={isSearchable}
          maxMenuHeight={maxMenuHeight}
          getOptionValue={getOptionValue}
          className="w-full h-[56px]"
          data-cy="select-dropdown"
        />

        <Show iff={Boolean(helperText)}>
          <FormHelperText
            mt={0}
            fontSize={14}
            display="block"
            color="#515151"
            lineHeight="28px"
            data-cy="select-form-helper-text"
          >
            {helperText}
          </FormHelperText>
        </Show>
      </FormControl>
    );
  }
);

export default Select;
